import React from 'react';

export default function Alert(props) {
    return (
        <div className={'alert alert-' + (props.type || 'primary')} role="alert">
            {props.text}<br/>
            {props.children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/shared/utils/Alert.js